import React, { useEffect, useState } from 'react';
import {
  Badge,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
  Table,
} from 'reactstrap';
import userEventApi from '../../../../../api/userEventApi';
import { handleToastError } from '../../../../../helpers';
import useI18n from '../../../../../hooks/use-i18n';
import { formatHHmmDDMMYYYY } from '../../../../../helpers/format-time';
import { EVENT_LIVE_TRAINING_STATUS } from '../../../../../constants/constants';
import classnames from 'classnames';
import styles from 'styles/Unit.module.scss';
import { useSelector } from 'react-redux';
import { getColor, getColorText, getThemeColor } from 'store/settings';

const ModalDetail = (props) => {
  const { data, open, toggle } = props;
  const i18n = useI18n();
  const [events, setEvent] = useState(undefined);
  const [isBusy, setBusy] = useState(true);
  //Color Theme
  const themeStatus = useSelector(getThemeColor);
  const colorStatus = useSelector(getColor);
  const colorTextStatus = useSelector(getColorText);

  async function getEventHistories() {
    try {
      const response = await userEventApi.getEventHistories(data);
      setEvent(response?.data);
      setBusy(false);
    } catch (error) {
      handleToastError(error, i18n);
    }
  }
  useEffect(() => {
    getEventHistories();
  }, []);

  return (
    <Modal isOpen={open} toggle={toggle} className="modal-dialog-top" size="lg">
      <ModalHeader toggle={toggle}>
        <strong className="font-medium-4">Online training history</strong>
      </ModalHeader>
      <ModalBody>
        {events === undefined ? (
          <div className="m-2 flexRow justify-content-center">
            <Spinner style={{ color: `${themeStatus}` }} />
          </div>
        ) : (
          <div>
            <div>
              <div className="overflow-auto">
                <Table responsive>
                  <thead className="thead-light">
                    <tr>
                      <th className={classnames('no-th', styles['no-th'])}>
                        No.
                      </th>
                      <th>Start time</th>
                      <th>End time</th>
                      <th className="w-50">Account</th>
                      <th
                        className={classnames('status-th', styles['status-th'])}
                      >
                        Status
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {events?.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>
                          {item?.startTime
                            ? formatHHmmDDMMYYYY(item?.startTime)
                            : null}
                        </td>
                        <td>
                          {item?.endTime
                            ? formatHHmmDDMMYYYY(item?.endTime)
                            : null}
                        </td>
                        <td>{item?.account}</td>
                        <td>
                          <Badge
                            color={`light-${
                              !item?.endTime &&
                              item?.status === EVENT_LIVE_TRAINING_STATUS.LIVING
                                ? 'danger'
                                : 'secondary'
                            }`}
                          >
                            {!item?.endTime &&
                            item?.status === EVENT_LIVE_TRAINING_STATUS.LIVING
                              ? 'Online'
                              : 'Stop'}
                          </Badge>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        )}
      </ModalBody>
      <ModalFooter className="px-05 py-05">
        <button
          className="btn-bg-color"
          onClick={toggle}
          style={{
            backgroundColor: `${colorStatus}`,
            color: `${colorTextStatus}`,
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = 'white';
            e.target.style.borderColor = colorStatus;
            e.target.style.color = colorStatus;
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = colorStatus;
            e.target.style.color = colorTextStatus;
          }}
        >
          Close
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalDetail;
